<template>
  <div class="flex justify-start gap-1" ref="menuWrapper">
    <div :class="`${menuClass} relative flex flex-wrap`">
      <template v-if="isMounted">
        <MenuItem
          v-for="item in visibleItems"
          :key="item.key"
          :item="item"
          class="btn max-w-60 px-4 py-2.5 hover:bg-gray-200 dark:hover:bg-neutral-700"
          item-active-class="btn-primary"
        />
      </template>
      <div
        v-for="item in allItems"
        :key="`${item.key}_sizes`"
        ref="menuItems"
        :class="`btn max-w-60 pointer-events-none absolute left-0 top-0 h-0 gap-2 overflow-hidden whitespace-nowrap px-4 py-0 opacity-0`"
      >
        <lucide-icon :icon="item.icon" size="16" class="shrink-0" />
        <span class="truncate">{{ $t(`routes.${item.key}`) }}</span>
      </div>
    </div>
    <Dropdown
      v-if="isMounted && dropdownItems.length"
      :fullscreen="false"
      :chevron-size="0"
      :y-offset="14"
      position="bottom-end"
      :hint="{
        position: 'bottom-center',
        yOffset: 8,
        text: $t('titles.More'),
        showDelay: 600,
      }"
      :button-class="`btn size-10 justify-center flex group ${
        isPageInDropdownActive
          ? 'bg-primary text-onPrimary hover:bg-primary-active'
          : 'bg-gray-100 text-primary hover:text-primary-active dark:bg-neutral-800 hover:bg-gray-200 dark:hover:bg-neutral-700'
      }`"
    >
      <template #label-icon>
        <lucide-icon
          icon="ChevronDown"
          class="transition-transform group-[.show]/dropdown:rotate-180"
          size="20"
        />
      </template>

      <template #content="{ closeDropdown }">
        <MenuItem
          v-for="item in dropdownItems"
          :key="item.key"
          :item="item"
          class="btn h-10 w-full px-3 hover:bg-gray-100 dark:hover:bg-neutral-700 md:h-9"
          item-active-class="btn-primary"
          @pageChanged="closeDropdown"
        />
      </template>
    </Dropdown>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import MenuItemsMixin from './menuItemsMixin.js';
import MenuItem from './MenuItem.vue';
import Dropdown from '@/components/ui/Dropdown';

export default {
  name: 'ExpandableMenu',
  mixins: [MenuItemsMixin],

  components: {
    MenuItem,
    Dropdown,
  },
  data() {
    return {
      visibleCount: null,
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters([
      'catalogSettings',
      'chessSettings',
      'infoSettings',
      'project',
      'interactiveSettings',
      'premisesSettings',
      'catalogs',
      'estates',
    ]),

    visibleItems() {
      return this.allItems.slice(0, this.visibleCount ?? this.allItems.length);
    },
    dropdownItems() {
      return this.allItems.slice(this.visibleCount ?? this.allItems.length);
    },
    isPageInDropdownActive() {
      return this.dropdownItems.some((item) => item.active);
    },
    allItems() {
      return this.menuItems.filter((i) => i.show);
    },
  },
  props: {
    menuClass: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.calculateVisibleItems();
    window.addEventListener('resize', this.calculateVisibleItems);
    this.isMounted = true;
  },
  methods: {
    ...mapActions(['LOAD_START']),
    calculateVisibleItems() {
      const moreButtonWidth = this.$windowSize.spacingSize * 10;
      const wrapperWidth = this.$refs.menuWrapper?.offsetWidth || 0;
      const availableWidth =
        wrapperWidth - moreButtonWidth - 2 * this.$windowSize.spacingSize;
      let total = 0;
      let count = 0;
      const items = this.$refs.menuItems;
      if (!items?.length) return;
      for (let el of items) {
        const width = el.offsetWidth;
        total += width;
        if (total > availableWidth) break;
        count++;
      }
      this.visibleCount = count;
      // this.visibleCount = 1;
    },
  },
};
</script>
